import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 6.75a4.5 4.5 0 000 9h10.5a4.49 4.49 0 003.182-1.318 4.49 4.49 0 001.318-3.182 4.49 4.49 0 00-1.318-3.182A4.49 4.49 0 0017.25 6.75a4.49 4.49 0 00-3.182 1.318 4.49 4.49 0 00-1.318 3.182m-6-3.75a5.25 5.25 0 019.645-2.873M15.25 20.821l-.75 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.35 20.446l-.75 1.3 1.3.75.75-1.3-1.3-.75zm2.995-5.188L10.1 19.146l1.3.75 2.245-3.888-1.3-.75zM4.1 20.446l-.75 1.3 1.3.75.75-1.3-1.3-.75zm2.994-5.187L4.85 19.146l1.3.75 2.244-3.887-1.3-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.326 15.493L16 19.521"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 6.75a4.5 4.5 0 000 9h10.5a4.49 4.49 0 003.182-1.318 4.49 4.49 0 001.318-3.182 4.49 4.49 0 00-1.318-3.182A4.49 4.49 0 0017.25 6.75a4.49 4.49 0 00-3.182 1.318 4.49 4.49 0 00-1.318 3.182m-6-3.75a5.25 5.25 0 019.645-2.873M15.25 20.821l-.75 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.35 20.446l-.75 1.3 1.3.75.75-1.3-1.3-.75zm2.995-5.188L10.1 19.146l1.3.75 2.245-3.888-1.3-.75zM4.1 20.446l-.75 1.3 1.3.75.75-1.3-1.3-.75zm2.994-5.187L4.85 19.146l1.3.75 2.244-3.887-1.3-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.326 15.493L16 19.521"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 13.5a9 9 0 000 18h21a8.98 8.98 0 006.364-2.636A8.98 8.98 0 0043.5 22.5a8.98 8.98 0 00-2.636-6.364A8.98 8.98 0 0034.5 13.5a8.98 8.98 0 00-6.364 2.636A8.98 8.98 0 0025.5 22.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 15c0-5.798 4.702-10.5 10.5-10.5a10.49 10.49 0 018.79 4.754M30.5 41.643L29 44.24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.701 40.893l-1.5 2.598 2.598 1.5 1.5-2.598-2.598-1.5zm5.99-10.377l-4.49 7.776 2.598 1.5 4.49-7.775-2.598-1.5zM8.201 40.892l-1.5 2.598 2.598 1.5 1.5-2.597-2.598-1.5zm5.988-10.373L9.7 38.293l2.598 1.5 4.488-7.774-2.598-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36.652 30.986L32 39.042"
  }))
};
export var WeatherHail = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});